import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as tripActions from '../actions';
import { produceOn } from '../../../../../reducers/immer.helper';
export interface TripState {
  trips?: any[];
  currentData?: any;
  result?: any;
  isLoading?: boolean;
  actionInProgress?: boolean;
  actionSuccessful?: boolean;
}
export const initialState: TripState = {
  trips: [],
  currentData: {},
  result: '',
  isLoading: false,
  actionInProgress: false,
  actionSuccessful: true,
};

const tripReducer = createReducer(
  initialState,
  produceOn(tripActions.getTrip, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
  }),
  produceOn(tripActions.getTripSuccess, (draft, result) => {
    draft.trips = result.data;
    draft.isLoading = false;
    draft.currentData = {};
  }),
  produceOn(tripActions.getTripFailure, (draft, result) => {
    draft.isLoading = false;
  }),
  //create user
  produceOn(tripActions.createTrip, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = true;
    draft.actionSuccessful = false;
  }),
  produceOn(tripActions.createTripSuccess, (draft, result) => {
    draft.isLoading = false;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
    draft.currentData = result.data;
  }),
  produceOn(tripActions.createTripFailure, (draft, result) => {
    draft.isLoading = false;
    draft.actionSuccessful = false;
  }),

  //delete user
  produceOn(tripActions.deleteTrip, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = true;
    draft.actionSuccessful = false;
  }),
  produceOn(tripActions.deleteTripSuccess, (draft) => {
    draft.isLoading = false;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
  }),
  produceOn(tripActions.deleteTripFailure, (draft) => {
    draft.isLoading = false;
    draft.actionSuccessful = false;
  }),
  produceOn(tripActions.updateTrip, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = true;
    draft.actionSuccessful = false;
  }),

  produceOn(tripActions.updateTripSuccess, (draft, result) => {
    draft.isLoading = false;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
    draft.currentData = result.id;
  }),

  produceOn(tripActions.updateTripFailure, (draft) => {
    draft.isLoading = false;
    draft.actionSuccessful = false;
  }),

  produceOn(tripActions.getTripById, (draft) => {
    draft.isLoading = true;
    draft.actionInProgress = true;
    draft.actionSuccessful = false;
  }),

  produceOn(tripActions.getTripByIdSuccess, (draft, result) => {
    draft.currentData = result.data;
    draft.isLoading = false;
    draft.actionInProgress = false;
    draft.actionSuccessful = true;
  }),

  produceOn(tripActions.getTripByIdFailure, (draft) => {
    draft.isLoading = false;
    draft.actionSuccessful = false;
  }),

  produceOn(tripActions.ClearState, (draft: any) => {
    Object.keys(draft).forEach((key) => {
      delete draft[key];
    });
    Object.assign(draft, initialState);
  })
);

export function reducer(state: TripState | undefined, action: Action): any {
  return tripReducer(state, action);
}
